export default __webpack_public_path__ + "static/media/ontime-completeion.4ed61318.svg";